import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=1ce31165"
import script from "./Canvas.vue?vue&type=script&lang=js"
export * from "./Canvas.vue?vue&type=script&lang=js"
import style0 from "./Canvas.vue?vue&type=style&index=0&id=1ce31165&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports